import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {WebUser, User, UsersQueryResponse} from './_models'
import { pick } from 'lodash';
import { isValidString } from '../../../components/helpers';

const API_URL = process.env.REACT_APP_API_URL

const SERVLET_URL = `${API_URL}/UserServlet`;

const getUsers = (): Promise<UsersQueryResponse> => {

  return axios.get(`${SERVLET_URL}`)
  .then((res) => {
    // conform output to { data, payload } object.
    return {data : res.data , payload : {}};
  })
}

const getUsersByRole = (userType: string, productTypeID?: number) : Promise<WebUser[]> => {

  let url = `${API_URL}/UserServlet?role=${userType}`;

  if (productTypeID) {
    url += `&productTypeId=${productTypeID}`
  }

  return axios.get(url)
  .then(res => {
    return res.data;
  })
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
  .get(`${SERVLET_URL}/${id}`)
  .then((response: AxiosResponse<Response<User>>) => response.data)
  .then((response: Response<User>) => response.data)
}

const createUser = (user: WebUser) => {

  const data = {
    id: 0,
    ...pick(user, ['name', 'email', 'role', 'productTypes','requireReview'])
  }

  if (isValidString(user.password)) {
    Object.assign(data, { password: user.password });
  }

  return axios.post(`${SERVLET_URL}`,data)
}

const updateUser = (user: WebUser) => {

  const data = pick(user, ['id','name', 'email', 'role', 'productTypes','requireReview']);

  if (isValidString(user.password)) {
    Object.assign(data, { password: user.password });
  }

  return axios.put(`${SERVLET_URL}`, data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${SERVLET_URL}?id=${userId}`).then(() => {})
}

const loadUsers = async (userType: string, productTypeID: number, callback: Function) => {
  await getUsersByRole(userType, productTypeID)
  .then( data => {
    if (data && data.length > 0 && callback) {
      callback(data);
    }
  })
  .catch(err => {
    console.error(err);
  })
}

export {getUsers, getUsersByRole, deleteUser, getUserById, createUser, updateUser, loadUsers};
